// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__20_3P","inputWrap":"Table_inputWrap__38Qzl","col":"Table_col__2fBn3","bmiTooltip":"Table_bmiTooltip__2rJcw"};